import { createTheme } from '@mui/material/styles';
import { alexforbesBrand } from './brand/alexforbes';

const colors = {
  primary: {
    main: alexforbesBrand.colors.orange,
    light: alexforbesBrand.colors.orangeLight,
    dark: alexforbesBrand.colors.orangeDark,
    contrastText: '#ffffff',
  },
  secondary: {
    main: alexforbesBrand.colors.teal,
    light: alexforbesBrand.colors.tealLight,
    dark: alexforbesBrand.colors.tealDark,
    contrastText: '#ffffff',
  },
  success: {
    main: alexforbesBrand.colors.teal,
    light: alexforbesBrand.colors.tealLight,
    dark: alexforbesBrand.colors.tealDark,
    contrastText: '#ffffff',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#ffffff',
  },
  warning: {
    main: alexforbesBrand.colors.orange,
    light: '#ff9800',
    dark: '#e65100',
    contrastText: '#000000',
  },
  info: {
    main: alexforbesBrand.colors.tealLight,
    light: '#4db6ac',
    dark: alexforbesBrand.colors.tealDark,
    contrastText: '#ffffff',
  },
};

const baseTheme = {
  typography: {
    fontFamily: '"Segoe UI", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 600, lineHeight: 1.2 },
    h2: { fontSize: '2rem', fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: '1.75rem', fontWeight: 600, lineHeight: 1.4 },
    h4: { fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.4 },
    h5: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
    subtitle1: { fontSize: '1rem', fontWeight: 500 },
    subtitle2: { fontSize: '0.875rem', fontWeight: 500 },
    body1: { fontSize: '1rem', lineHeight: 1.5 },
    body2: { fontSize: '0.875rem', lineHeight: 1.5 },
    button: { textTransform: 'none', fontWeight: 500 },
    caption: { fontSize: '0.75rem' },
    overline: { fontSize: '0.75rem', fontWeight: 500 },
  },
  shape: { borderRadius: 6 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 6, padding: '8px 16px', fontWeight: 500 },
        contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
      },
    },
    MuiPaper: { styleOverrides: { root: { borderRadius: 6 } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 6 } } },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: colors.primary,
    secondary: colors.secondary,
    success: colors.success,
    error: colors.error,
    warning: colors.warning,
    info: colors.info,
    background: {
      default: alexforbesBrand.colors.background,
      paper: alexforbesBrand.colors.surface,
    },
    text: {
      primary: '#1A1A1A',
      secondary: alexforbesBrand.colors.greyMedium,
    },
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      ...colors.primary,
      main: alexforbesBrand.colors.tealLight,
      contrastText: '#000000',
    },
    secondary: colors.secondary,
    success: colors.success,
    error: colors.error,
    warning: colors.warning,
    info: colors.info,
    background: {
      default: '#0D1114',
      paper: '#1A2226',
    },
    text: {
      primary: '#F0F2F5',
      secondary: alexforbesBrand.colors.greyLight,
    },
  },
});

export default lightTheme;
